import React from 'react';
export enum Position {
    RIGHT = 'right',
    BOTTOM = 'bottom',
    POPUP_RELATIVE = 'popup-relative',
    POPUP_CENTERED = 'popup-centered',
    TOP_BAR = 'top-bar'
}
export enum Size {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large'
}
export interface ModalPanelConfiguration {
    isOpen: boolean | undefined;
    position: Position;
    toggle: () => void;
    children?: React.ReactNode;
    size?: Size;
    closeButton?: boolean;
}

const ModalPanel = ({ isOpen = false, position, toggle, children, size, closeButton }: ModalPanelConfiguration) => {
    const innerClassname = ['panel', position, size, isOpen ? 'open' : 'closed'].filter(Boolean).join(' ');
    return (
        <div className='modal-panel'>
            {isOpen && position !== Position.TOP_BAR && <div onClick={toggle} className='overlay'></div>}
            <div className={innerClassname}>
                {children}
                {closeButton && <button className='close-button' onMouseDown={toggle}></button>}
            </div>
        </div>
    );
};
export default ModalPanel;
